export default {
    chats: {
        start: {
            events: [
                {
                    tasks: [
                        {
                            method: "Reply",
                            data: {
                                reply_markup: {
                                    keyboard: [
                                        [
                                            {
                                                text: "World Summary",
                                                id: "96682"
                                            }
                                        ],
                                        [
                                            {
                                                text: "Country wise summary",
                                                id: "48910"
                                            }
                                        ]
                                    ],
                                    resize_keyboard: true
                                },
                                text:
                                    "Hi {{ first_name }},\nI can help you to quickly glance over the covid19 cases around the world.\n\n<b> STAY HOME , STAY SAFE </b>\n\n\n"
                            },
                            error: false
                        }
                    ]
                }
            ]
        },
        "world summary": {
            events: [
                {
                    tasks: [
                        {
                            method: "HttpRequest",
                            data: {
                                method: "get",
                                body: "{}",
                                error: "{{http_result}}",
                                url: "https://api.covid19api.com/summary"
                            },
                            error: false
                        },
                        {
                            method: "Reply",
                            data: {
                                reply_markup: null,
                                text:
                                    "<b>World Summary</b>\nTotal Confirmed : {{http_result.Global.TotalConfirmed}}\nTotal Deaths : {{http_result.Global.TotalDeaths}}\nTotal Recovered : {{http_result.Global.TotalRecovered}}"
                            },
                            error: false
                        }
                    ]
                }
            ]
        },
        "country wise summary": {
            events: [
                {
                    tasks: [
                        {
                            method: "Reply",
                            data: {
                                reply_markup: null,
                                text: "Provide Country Name"
                            },
                            error: false
                        }
                    ]
                },
                {
                    tasks: [
                        {
                            method: "CaptureData",
                            data: {
                                values: [
                                    {
                                        value: "user_input",
                                        key: "country"
                                    }
                                ]
                            },
                            error: false
                        },
                        {
                            method: "HttpRequest",
                            data: {
                                method: "get",
                                body: "{}",
                                error:
                                    "Country name not found, Please try with different name.",
                                url:
                                    "https://api.covid19api.com/total/country/{{country}}"
                            },
                            error: false
                        },
                        {
                            method: "Reply",
                            data: {
                                reply_markup: null,
                                text:
                                    "<b>{{country}} Summary</b> \nDate : {{http_result[-1].Date}}\n\nTotal Confirmed : {{http_result[-1].Confirmed}}\nTotal Deaths : {{http_result[-1].Deaths}}\nTotal Recovered : {{http_result[-1].Recovered}}\nTotal Active : {{http_result[-1].Active}}\n\n"
                            },
                            error: false
                        }
                    ]
                }
            ]
        }
    },
    actions: {
        callbacks: [],
        commands: [
            {
                description: "Start chatting with bot",
                admin: false,
                error: false,
                command: "start",
                chat: "start"
            }
        ],
        reply_buttons: [
            {
                button: {
                    text: "World Summary",
                    id: "96682"
                },
                chat: "world summary"
            },
            {
                button: {
                    text: "Country wise summary",
                    id: "48910"
                },
                chat: "country wise summary"
            }
        ]
    },
    variables: {}
};